import { render } from "./SelectButtons.vue?vue&type=template&id=88fc7ff4&scoped=true"
import script from "./SelectButtons.vue?vue&type=script&lang=js"
export * from "./SelectButtons.vue?vue&type=script&lang=js"

import "./SelectButtons.vue?vue&type=style&index=0&id=88fc7ff4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88fc7ff4"]])

export default __exports__